import { B2B_SET_TRANSLATION_ACTION } from './actions';

const initialState = {
    b2bTrans: ''
};

export const b2bReducer = ( state = initialState, action ) => {

    let result = '';

    switch ( action.type ) {

        case B2B_SET_TRANSLATION_ACTION:
            result = { ...state, b2bTrans: action.payload };
            break;

        default:
            return state;

    }

    return result;

};